import * as React from "react";
import type { SVGProps } from "react";
const SvgTamLogoWhite = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="TAM-Logo-white_svg__Layer_1"
    x={0}
    y={0}
    viewBox="0 0 167.8 137.8"
    {...props}
  >
    <style>
      {
        ".TAM-Logo-white_svg__st0{fill:#b1b3b6}"
      }
    </style>
    <path
      d="m100.1 122.9 5.3-5.5v15.1l-5.3-5.1z"
      className="TAM-Logo-white_svg__st0"
    />
    <path
      d="M166.3 45.2h-17.7l-.4.9-12.1 25.1L124 46.1l-.4-.9H105v11.7h4.3v36h-4.5v11.6h21.1V92.9h-4.6V67.3l13.5 27.9 1.3 2.8 1.4-2.8 13.7-28v25.7h-4.6v11.6H167.8V92.9h-4.6v-36h4.6V45.2zM40 104.5h22.8V92.8h-6.3L40.8 56.7h3V45H18.7v11.7h3.5L6.5 92.8H0v11.6h22.8V92.8h-3.3l2.6-6h18.8l2.6 6H40v11.7zM27.1 75.2 31.5 65l4.4 10.1h-8.8z"
      className="TAM-Logo-white_svg__st1"
    />
    <path
      d="M96.4 112.4V23h26.9v14.2h25.6V0H18.5V37.4h25.4V23H71v89.4H56.6v25.4H110.8v-25.4H109zM123 132.9c.8-.1 1.4-.8 1.3-1.6 0-1.2-.8-1.7-2.2-1.7h-2.2v5.9h1.1V133h.7l1.5 2.6h1.1l-1.6-2.6c.1-.1.2-.1.3-.1zm-2-.9v-1.7h1c.6 0 1.2 0 1.2.8s-.6.9-1.2.9h-1z"
      className="TAM-Logo-white_svg__st1"
    />
    <path
      d="M121.9 127.3c-2.9 0-5.2 2.3-5.2 5.2 0 2.9 2.3 5.2 5.2 5.2 2.9 0 5.2-2.3 5.2-5.2s-2.4-5.2-5.2-5.2zm3.9 5.3c0 2.2-1.7 4-3.9 4.1-2.1 0-3.8-1.6-3.9-3.7-.1-2.2 1.5-4 3.7-4.2 2.2-.1 4 1.5 4.2 3.7l-.1.1z"
      className="TAM-Logo-white_svg__st1"
    />
    <path
      d="m85.7 123.1 5.4-5.3V17.9l-5.4-5.4zM23.5 5.2l5.6 5.4H134l6.9-5.4zM138.4 13.6v13.6l5.4 5.2V8z"
      className="TAM-Logo-white_svg__st0"
    />
  </svg>
);
export default SvgTamLogoWhite;
